import { useState } from "react";
import { Link } from "react-router-dom";

const KEY = "privacy_acknowledged";

export default function PrivacyBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(KEY));

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 900,
      background: "var(--ink)",
      borderTop: "2px solid var(--orange)",
      padding: "14px 24px",
      display: "flex",
      alignItems: "center",
      gap: 16,
      flexWrap: "wrap",
    }}>
      <p style={{
        flex: 1,
        margin: 0,
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 11,
        color: "var(--gray)",
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        minWidth: 240,
      }}>
        We store authentication tokens locally and log IP addresses on comments for spam prevention. No ad trackers.{" "}
        <Link
          to="/privacy"
          style={{ color: "var(--orange)", textDecoration: "none", borderBottom: "1px dotted var(--orange)" }}
        >
          Privacy Policy
        </Link>
      </p>
      <button
        onClick={dismiss}
        style={{
          padding: "6px 18px",
          background: "transparent",
          color: "var(--orange)",
          border: "2px solid var(--orange)",
          cursor: "pointer",
          fontFamily: "'Archivo Black', sans-serif",
          fontSize: "0.65rem",
          fontWeight: 900,
          textTransform: "uppercase",
          letterSpacing: "1px",
          flexShrink: 0,
          transition: "background 0.15s, color 0.15s",
        }}
        onMouseEnter={e => { e.currentTarget.style.background = "var(--orange)"; e.currentTarget.style.color = "var(--ink)"; }}
        onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "var(--orange)"; }}
      >
        Got it
      </button>
    </div>
  );
}
